module.exports = __webpack_public_path__ + "static/img/4.1da78cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/4.jpg
// module id = CsDI
// module chunks = 1